import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import Solutions from "../pages/solutions/page";
import Cases from "../pages/cases/page";
import About from "../pages/about/page";
import Insights from "../pages/insights/page";
import ArticleDetail from "../pages/insights/article/page";
import Contact from "../pages/contact/page";
import Privacy from "../pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/insights",
    element: <Insights />,
  },
  {
    path: "/insights/article/:slug",
    element: <ArticleDetail />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;